"use client";
import Link from "next/link";
import Container from "../components/container/Container.tsx";
import React from "react";

const NavBar = () => {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const href = e.currentTarget.href.split("#")[1];
    window.scrollTo({
      top: document.getElementById(href)?.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <nav className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-[340px] sm:max-w-[383px] md:top-auto md:bottom-10 lg:max-w-[391px]">
      <Container
        width="100%"
        height="50px"
        color="rgba(255, 255, 255, 0.1)"
        borderRadius={10}
        top="0px"
        left="0px"
        angle={0}
      >
        <div className="flex h-full w-full items-center justify-center gap-2 px-2 text-[#e4ded7] sm:gap-4 md:gap-6">
          <Link
            href="#work"
            data-blobity-magnetic="false"
            onClick={handleScroll}
            aria-label="Scroll to Work Section"
            className="transition-colors duration-300 hover:text-white"
          >
            <h4 className="px-2 py-2 text-[11px] font-medium sm:text-[12px] md:text-[14px]">
              RÉALISATIONS
            </h4>
          </Link>

          <Link
            href="#tools"
            data-blobity-magnetic="false"
            onClick={handleScroll}
            aria-label="Scroll to Stack Section"
            className="transition-colors duration-300 hover:text-white"
          >
            <h4 className="px-2 py-2 text-[11px] font-medium sm:text-[12px] md:text-[14px]">
              TECHNO
            </h4>
          </Link>

          <Link
            href="#contact"
            data-blobity-magnetic="false"
            onClick={handleScroll}
            aria-label="Scroll to Contact Section"
            className="transition-colors duration-300 hover:text-white"
          >
            <h4 className="px-2 py-2 text-[11px] font-medium sm:text-[12px] md:text-[14px]">
              CONTACT
            </h4>
          </Link>
        </div>
      </Container>
    </nav>
  );
};

export default NavBar;
